export function parseHarvestProofApiError(error: unknown): string {
  if (!(error instanceof Error)) {
    return 'Une erreur est survenue.';
  }

  try {
    const parsed = JSON.parse(error.message) as Record<string, unknown>;

    if (typeof parsed.detail === 'string') {
      return parsed.detail;
    }

    const fieldMessages = Object.entries(parsed)
      .filter(([, value]) => typeof value === 'string' || Array.isArray(value))
      .flatMap(([key, value]) => {
        if (Array.isArray(value)) {
          return value.map((item) => `${key}: ${String(item)}`);
        }
        return [`${key}: ${String(value)}`];
      });

    if (fieldMessages.length > 0) {
      return fieldMessages.join(' ');
    }
  } catch {
    // not JSON
  }

  return error.message || 'Une erreur est survenue.';
}
